module.exports = __webpack_public_path__ + "static/img/client-1.e96b1a0f.png";